import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrepareGuard, AuthGuard } from 'app/core/core.module';
import { TableEditComponent } from './table-edit/table-edit.component';
import { CustomerSearchComponent } from './customer-search/customer-search.component';
import { ShippingAddressDialogComponent } from './shipping-address-dialog/shipping-address-dialog.component';
import { UserSearchComponent } from './user-search/user-search.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { EmailInfoComponent } from './email-info/email-info.component';
import { SalesEmailDialogComponent } from './sales-email-dialog/sales-email-dialog.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { QuickbooksComponent } from './quickbooks/quickbooks.component';
import { QuickbooksExportDialogComponent } from './quickbooks-export-dialog/quickbooks-export-dialog.component';
import { ChangeHistoryComponent } from './change-history/change-history.component';
import { SalesRepDialogComponent } from './sales-rep-dialog/sales-rep-dialog.component';
import { StateTaxExemptionDialogComponent } from './state-tax-exemption-dialog/state-tax-exemption-dialog.component';
import { LineItemDialogComponent } from './line-item-dialog/line-item-dialog.component';
import { PartPurchasesComponent } from 'app/parts/part-purchases/part-purchases.component';
import { FeeTypeDialogComponent } from './fee-type-dialog/fee-type-dialog.component';
import { ConfirmationPaymentMethodDialogComponent } from './confirmation-payment-method-dialog/confirmation-payment-method-dialog.component';
import { DeliveryOptionDialogComponent } from './delivery-option-dialog/delivery-option-dialog.component';
import { InvoicePaymentMethodDialogComponent } from './invoice-payment-method-dialog/invoice-payment-method-dialog.component';
import { DealerTermDialogComponent } from './dealer-term-dialog/dealer-term-dialog.component';
import { EmailTemplateDialogComponent } from './email-template-dialog copy/email-template-dialog.component';
import { PartConfiguratorComponent } from './part-configurator/part-configurator.component';
import { NameValueDialogComponent } from './dialogs/name-value-dialog.component';
import { ModelTypeDialogComponent } from './dialogs/model-type-dialog.component';
import { ModelSizeDialogComponent } from './dialogs/model-size-dialog.component';
import { SuspensionDialogComponent } from './dialogs/suspension-dialog.component';
import { VendorTermDialogComponent } from './vendor-term-dialog/vendor-term-dialog.component';
import { PricingTierDialogComponent } from './pricing-tier-dialog/pricing-tier-dialog.component';
import { WinchStandDialogComponent } from './dialogs/winch-stand-dialog.component';
import { PurchaseOrderShipAddressDialogComponent } from './purchase-order-ship-address-dialog/purchase-order-ship-address-dialog.component';
import { TireDialogComponent } from './dialogs/tire-dialog.component';

@NgModule({
    imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule.forChild([
        {
            path: 'admin',
            component: BasicLayoutComponent,
            children: [
                { path: '', redirectTo: 'tables', pathMatch: 'full' },
                { path: 'users', component: UserSearchComponent, data: { title: 'Users' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'customers', component: CustomerSearchComponent, data: { title: 'Customers' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'change-history', component: ChangeHistoryComponent, data: { title: 'Change History' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'email-info', component: EmailInfoComponent, data: { title: 'Email Info' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'quickbooks', component: QuickbooksComponent, data: { title: 'Quickbooks' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'users/:id', component: UserDetailComponent, data: { title: 'User Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'lookup-tables', component: TableEditComponent, data: { title: 'Lookup Tables' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'adjustments', component: PartPurchasesComponent, data: { title: 'Adjustments' }, canActivate: [AuthGuard, PrepareGuard] },
                { path: 'part-configurator', component: PartConfiguratorComponent, data: { title: 'Part Configurator' }, canActivate: [AuthGuard, PrepareGuard] },
            ],
        },
    ]),
],
    declarations: [
        TableEditComponent,
        CustomerSearchComponent,
        ChangeHistoryComponent,
        ShippingAddressDialogComponent,
        UserSearchComponent,
        UserDetailComponent,
        EmailInfoComponent,
        EmailTemplateDialogComponent,
        SalesEmailDialogComponent,
        QuickbooksComponent,
        QuickbooksExportDialogComponent,
        SalesRepDialogComponent,
        StateTaxExemptionDialogComponent,
        LineItemDialogComponent,
        FeeTypeDialogComponent,
        ConfirmationPaymentMethodDialogComponent,
        DeliveryOptionDialogComponent,
        InvoicePaymentMethodDialogComponent,
        DealerTermDialogComponent,
        PartConfiguratorComponent,
        NameValueDialogComponent,
        ModelTypeDialogComponent,
        ModelSizeDialogComponent,
        SuspensionDialogComponent,
        VendorTermDialogComponent,
        PricingTierDialogComponent,
        WinchStandDialogComponent,
        PurchaseOrderShipAddressDialogComponent,
        TireDialogComponent
    ]
})
export class AdminModule { }
